import { createContext, useContext } from 'react';

export interface WindowContextProps {
    component?: () => JSX.Element;
    openWindow?: (args: WindowContextProps) => void;
    closeWindow?: () => void;
    isOpened?: boolean;
    props?: any;
    customImage?: {
        Image?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
        className?: string;
    };
    safeAreaColor?: string; // Couleur de fond de la safe area (encoche/cutout) quand la fenêtre est ouverte
}

export const WindowContext = createContext<WindowContextProps>({
    component: undefined,
    openWindow: () => {},
    closeWindow: () => {},
    isOpened: false,
    props: {}
});

export const useWindow = () => useContext(WindowContext);
